'use client';
import { App } from '@web/query/App';
function Configs() {
  App.useConfigs();

  return null;
}

export { Configs };
